import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr } from '@ember-data/model';
import { formatEuro } from 'beebee-base/lib/utility';
import { cached } from '@glimmer/tracking';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
let ExpensearticleModel = (_dec = belongsTo('expense', {
  inverse: 'expensearticles',
  async: false
}), _dec2 = attr('string'), _dec3 = attr('number', {
  currency: true
}), _dec4 = attr('number', {
  currency: true
}), _dec5 = attr('number', {
  defaultValue: 1
}), _dec6 = attr('number'), _dec7 = attr('boolean'), _dec8 = attr('number', {
  defaultValue: 100
}), _dec9 = attr('number', {
  defaultValue: 22
}), _dec0 = attr('string'), _dec1 = attr('boolean'), _dec10 = belongsTo('category', {
  inverse: null,
  async: false
}), _dec11 = belongsTo('sub_category', {
  inverse: null,
  async: false
}), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('boolean', {
  defaultValue: false
}), _class = class ExpensearticleModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "expense", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "price", _descriptor3, this);
    _initializerDefineProperty(this, "importo", _descriptor4, this);
    _initializerDefineProperty(this, "qta", _descriptor5, this);
    _initializerDefineProperty(this, "first_rate", _descriptor6, this);
    _initializerDefineProperty(this, "first_rate_included", _descriptor7, this);
    _initializerDefineProperty(this, "iva_det", _descriptor8, this);
    _initializerDefineProperty(this, "iva_rate", _descriptor9, this);
    _initializerDefineProperty(this, "iva_natura", _descriptor0, this);
    _initializerDefineProperty(this, "ritenuta", _descriptor1, this);
    _initializerDefineProperty(this, "category", _descriptor10, this);
    _initializerDefineProperty(this, "sub_category", _descriptor11, this);
    _initializerDefineProperty(this, "invoice_id", _descriptor12, this);
    _initializerDefineProperty(this, "contact_id", _descriptor13, this);
    _initializerDefineProperty(this, "event_id", _descriptor14, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor15, this);
  }
  get iva_det_imp() {
    const importo = this.importo ?? 0;
    const ivaDetraibilePercent = this.iva_det ?? 100;
    const ivaRatePercent = this.iva_rate ?? 0;
    const isPrezzoLordo = this.expense?.lordo ?? false;
    const grossDivisor = 1 + ivaRatePercent / 100;
    const ivaTotale = isPrezzoLordo ? grossDivisor !== 0 ? importo - importo / grossDivisor : 0 : importo * (ivaRatePercent / 100);
    const importoIvaDetraibile = ivaTotale * (ivaDetraibilePercent / 100);
    return formatEuro(importoIvaDetraibile);
  }
  get rand_id() {
    return `rid-${Math.random().toString(36).substring(2, 8)}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "expense", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "importo", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "qta", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "first_rate", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "first_rate_included", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "iva_det", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "iva_det_imp", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "iva_det_imp"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "iva_rate", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "iva_natura", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "ritenuta", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "category", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sub_category", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "invoice_id", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "contact_id", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "event_id", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "rand_id", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "rand_id"), _class.prototype), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ExpensearticleModel as default };
//# sourceMappingURL=expensearticle.js.map
